import {issueConstants} from '../constants/issue.constants'
import {createAPIClient} from '../services/api'
import {head, get} from 'lodash'

export function getIssuesAction (filterParams, successCallback) {
  return dispatch => {
    dispatch(request())  // could be removed
    const api = createAPIClient()

    api.get(`/api/private/frontend/issues`, {params: filterParams})
      .then(result => {
        const {data: body} = result
        const {response} = body
        const issues = response.items
        const count = response.count
        var rawCustomFields = get(head(response.items), 'template.custom_fields') || []
        if (rawCustomFields.length === 0) {
          api.get(`/api/templates/${filterParams.template}`)
            .then(template => {
              console.log(template)
              rawCustomFields = template.data.response.custom_fields
              rawCustomFields.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0) })
              const customFields = rawCustomFields.map(item => ({name: item.name, id: item.id, value_type: item.value_type, list_values: item.list_values, required: item.required}))
              dispatch(success({customFields, issues}))
              successCallback(count)
            })
        } else {
          rawCustomFields.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0) })
          const customFields = rawCustomFields.map(item => ({name: item.name, id: item.id, value_type: item.value_type, list_values: item.list_values, required: item.required}))
          dispatch(success({customFields, issues}))
          successCallback(count)
        }
      })
      .catch(error => {
        dispatch(failure(error))
      })
  }

  function request () {
    return {type: issueConstants.GETALL_REQUEST}
  }

  function success (payload) {
    return {type: issueConstants.GETALL_SUCCESS, payload}
  }

  function failure (error) {
    return {type: issueConstants.GETALL_FAILURE, error}
  }
}

export function startDateChangeAction (date) {
  return dispatch => {
    dispatch({type: issueConstants.START_DATE_CHANGE, date})
  }
}

export function endDateChangeAction (date) {
  return dispatch => {
    dispatch({type: issueConstants.END_DATE_CHANGE, date})
  }
}

export function deleteIssueAction (id) {
  return dispatch => {
    dispatch(request())
    const api = createAPIClient()
    api.delete(`/api/issues/${id}`)
      .then(result => {
        dispatch(success(result))
      })
      .catch(error => {
        dispatch(failure(error))
      })
  }

  function request () {
    return {type: issueConstants.DELETE_ISSUE_REQUEST}
  }

  function success (payload) {
    return {type: issueConstants.DELETE_ISSUE_SUCCESS, payload}
  }

  function failure (error) {
    return {type: issueConstants.DELETE_ISSUE_FAILURE, error}
  }
}

export function updateIssueAction (id, form, onSubmissionResults) {
  return dispatch => {
    dispatch(request(id))
    const api = createAPIClient()
    api.put(`/api/issues/${id}`, form)
      .then(results => {
        dispatch(success(results))
        onSubmissionResults(true)
      })
      .catch(error => {
        dispatch(failure(error))
        onSubmissionResults(false)
      })
  }

  function request (id) {
    return {type: issueConstants.UPDATE_ISSUE_REQUEST, id}
  }

  function success (payload) {
    return {type: issueConstants.UPDATE_ISSUE_SUCCESS, payload}
  }

  function failure (error) {
    return {type: issueConstants.UPDATE_ISSUE_FAILURE, error}
  }
}

export function createIssueAction (form, onSubmissionResults) {
  return dispatch => {
    const api = createAPIClient()
    api.post(`/api/issues/`, form)
      .then(results => {
        dispatch(success(results))
        onSubmissionResults(true)
      })
      .catch(error => {
        var errorMessage = error.response.data.meta.error.payload.message
        dispatch(failure(error))
        onSubmissionResults(false, errorMessage)
      })
  }

  function request (id) {
    return {type: issueConstants.UPDATE_ISSUE_REQUEST, id}
  }

  function success (payload) {
    return {type: issueConstants.UPDATE_ISSUE_SUCCESS, payload}
  }

  function failure (error) {
    return {type: issueConstants.UPDATE_ISSUE_FAILURE, error}
  }
}

export function updateIssueStatus (id, form) {
  return dispatch => {
    const api = createAPIClient()
    api.put(`/api/issues/${id}`, form)
      .then(result => {
        dispatch(success())
      })
      .catch(error => {
        dispatch(failure(error))
      })
  }
  function success () {
    return {type: issueConstants.UPDATE_ISSUE_STATUS_SUCCESS}
  }

  function failure (error) {
    return {type: issueConstants.UPDATE_ISSUE_STATUS_FAILURE, payload: error}
  }
}



// WEBPACK FOOTER //
// ./src/actions/issues.action.js